export default "__VITE_ASSET__C$nJeh0b__";